import { Route, Routes } from "react-router-dom";
import FilePreviewPage from "../pages/FilePreviewPage";

const FILE_PREVIEW_STANDALONE_PATH_PATTERN = /^\/file-preview\/[^/]+\/?$/;

export function isFilePreviewStandalonePath(pathname: string): boolean {
  return FILE_PREVIEW_STANDALONE_PATH_PATTERN.test(pathname);
}

function FilePreviewAccessDenied() {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#6b7280",
        background: "#fff",
      }}
    >
      Bạn chưa đăng nhập hoặc phiên đăng nhập đã hết hạn. Vui lòng đăng nhập để
      xem trước file.
    </div>
  );
}

function hasPreviewAccessToken(): boolean {
  return Boolean(localStorage.getItem("accessToken"));
}

function FilePreviewStandaloneRoot() {
  if (!hasPreviewAccessToken()) {
    return <FilePreviewAccessDenied />;
  }

  return (
    <Routes>
      <Route path="/file-preview/:fileId" element={<FilePreviewPage />} />
    </Routes>
  );
}

export default FilePreviewStandaloneRoot;
